import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from "nprogress";
import 'nprogress/nprogress.css';
import mmpublic from '@/views/Public/Index.vue';
import { pwddecode,sessionRead } from '../global.js' // 自定公共函
/**
 * 重写路由的push方法
 * 解决，相同路由跳转时，报错
 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter)

const routes = [{
  path: "/",
  component: mmpublic,
  children: [{
    path: "/",
    component: () => import("@/views/Home/Index.vue"),
  }]
}, {
  path: "/Login",
  name: "Login",
  component: () => import("@/views/Login/Index.vue"),
}, {
  path: "*", // 避免未定義的路由
  redirect: "/",
},]



const router = new VueRouter({
  routes: routes
})
// 进行路由守卫进行登录判断
// 路由守卫白名单设置
const whiteRouter = ["/Login"];

router.beforeEach((to, from, next) => {
  NProgress.start();
  let token = sessionRead('token');
  let username = sessionRead('username');
  let mso_id = sessionRead('mso_id');
  if (token && username && mso_id) {
    if (to.path === "/Login") {
      sessionStorage.clear();
    } else {
      next();
    }
  } else {
    // 判断需要进入的页面是否为白名单中的页面,
    // 如果是则直接进入，如果没有改步判断，会一直处于死循环中
    if (whiteRouter.indexOf(to.path) !== -1) {
      next();
    } else {
      NProgress.done()
      next("/Login");
    }
  }
});
router.afterEach(() => {
  NProgress.done();
});
export default router